import type { ReactElement } from "react";
import { Route } from "react-router";
import * as ROUTES from "../constants/routes";
import { SupplierOnboardingPage } from "../pages/supplierOnboarding/SupplierOnboardingPage";
import { SupplierOnboardingLayout } from "../pages/supplierOnboarding/SupplierOnboardingLayout";
import type { AuthenticatedAccessMode } from "./resolveAuthenticatedAccessMode";
import { RouteAccessBoundary } from "./RouteAccessBoundary";

export const renderSupplierOnboardingRoutes = ({
  accessMode,
  renderFallback,
}: {
  accessMode: AuthenticatedAccessMode;
  renderFallback: () => ReactElement;
}): ReactElement => (
  <Route element={<SupplierOnboardingLayout />}>
    <Route
      element={
        <RouteAccessBoundary
          isAllowed={accessMode === "supplier-onboarding"}
          renderFallback={
            accessMode === "supplier-onboarding-denied"
              ? () => <SupplierOnboardingPage hasAccess={false} />
              : renderFallback
          }
        />
      }
    >
      <Route
        path={ROUTES.SUPPLIER_ONBOARDING}
        element={<SupplierOnboardingPage />}
      />
    </Route>
  </Route>
);
